import { render } from "./EditProfileForm.vue?vue&type=template&id=1ed6d3f5&scoped=true"
import script from "./EditProfileForm.vue?vue&type=script&lang=js"
export * from "./EditProfileForm.vue?vue&type=script&lang=js"

import "@/Common/Styles/editProfileForm.scss?vue&type=style&index=0&id=1ed6d3f5&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed6d3f5"]])

export default __exports__